import React, { useState, useEffect } from "react";

const NumberInputWithCommas = ({
  AddClass,
  width = '',
  defaultValue,
  formattedNumber,
  setFormattedNumber,
  handlepriceChange,
  id='1',
  labelValue
}) => {
  // const { formattedNumber, setFormattedNumber, handlepriceChange } =
  //   useStateContext();
  const lab = labelValue ? labelValue : "قیمت (تومان)";
  useEffect(() => {
    // Set initial value from defaultValue prop
    if (defaultValue !== undefined) {
      // Remove thousands separator from defaultValue prop
      const number = Number(defaultValue.replace(/,/g, ""));
      const formatted = new Intl.NumberFormat().format(number);
      setFormattedNumber(formatted);
    }
  }, [defaultValue]);
  
  return (
    <div className={`flex flex-col w-full ${width}`}>
      <label
        htmlFor="numberInput"
        className="text-dark-blue-200 text-12 font-normal leading-5 mb-2.5">
        {lab}
      </label>
      <div className="flex flex-row bg-gray-chart-200 w-full px-3.5 gap-2.5 items-center rounded-sm  h-12.6">
        <input
          type="text"
          id={id}
          className={`bg-gray-chart-200 outline-none text-dark-blue-200 text-13 py-3.5 w-full ${AddClass}`}
          value={formattedNumber}
          onChange={handlepriceChange}
          placeholder=" مانند 6,000,000"
        />
      </div>
    </div>
  );
};

export default NumberInputWithCommas;
